/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiAssignedScreeningAlert,
    ApiAssignedScreeningAlertFromJSON,
    ApiAssignedScreeningAlertToJSON,
    ApiSanctionAlerts,
    ApiSanctionAlertsFromJSON,
    ApiSanctionAlertsToJSON,
    ApiSortDirection,
    ApiSortDirectionFromJSON,
    ApiSortDirectionToJSON,
} from '../models';

export interface AssignNextFromFilterRequest {
    filterId: number;
    direction: ApiSortDirection;
    offsetId?: number;
}

export interface FindFilterResultsRequest {
    filterId: number;
    direction: ApiSortDirection;
    size: number;
    offsetId?: number;
    offsetCreatedTime?: Date;
}

/**
 * 
 */
export class ScreeningAlertFilterResultsApi extends runtime.BaseAPI {

    /**
     */
    async assignNextFromFilterRaw(requestParameters: AssignNextFromFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiAssignedScreeningAlert>> {
        if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
            throw new runtime.RequiredError('filterId','Required parameter requestParameters.filterId was null or undefined when calling assignNextFromFilter.');
        }

        if (requestParameters.direction === null || requestParameters.direction === undefined) {
            throw new runtime.RequiredError('direction','Required parameter requestParameters.direction was null or undefined when calling assignNextFromFilter.');
        }

        const queryParameters: any = {};

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.offsetId !== undefined) {
            queryParameters['offsetId'] = requestParameters.offsetId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-alerts/filters/{filterId}/next/assignee`.replace(`{${"filterId"}}`, encodeURIComponent(String(requestParameters.filterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiAssignedScreeningAlertFromJSON(jsonValue));
    }

    /**
     */
    async assignNextFromFilter(requestParameters: AssignNextFromFilterRequest, initOverrides?: RequestInit): Promise<ApiAssignedScreeningAlert> {
        const response = await this.assignNextFromFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findFilterResultsRaw(requestParameters: FindFilterResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiSanctionAlerts>> {
        if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
            throw new runtime.RequiredError('filterId','Required parameter requestParameters.filterId was null or undefined when calling findFilterResults.');
        }

        if (requestParameters.direction === null || requestParameters.direction === undefined) {
            throw new runtime.RequiredError('direction','Required parameter requestParameters.direction was null or undefined when calling findFilterResults.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findFilterResults.');
        }

        const queryParameters: any = {};

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.offsetId !== undefined) {
            queryParameters['offsetId'] = requestParameters.offsetId;
        }

        if (requestParameters.offsetCreatedTime !== undefined) {
            queryParameters['offsetCreatedTime'] = (requestParameters.offsetCreatedTime as any).toISOString();
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-alerts/filters/{filterId}/results`.replace(`{${"filterId"}}`, encodeURIComponent(String(requestParameters.filterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiSanctionAlertsFromJSON(jsonValue));
    }

    /**
     */
    async findFilterResults(requestParameters: FindFilterResultsRequest, initOverrides?: RequestInit): Promise<ApiSanctionAlerts> {
        const response = await this.findFilterResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
